import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "k-menu"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "k-menu__title" }, " RE:PAINT ", -1)
const _hoisted_3 = { class: "k-menu__play" }
const _hoisted_4 = { class: "k-menu__opts" }
const _hoisted_5 = { class: "k-menu__remove-ads" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-hand-index-thumb" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Remove Ads ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Thanks for your support! ")

import GlowButton from 'components/glow-button.vue';
import PlayButton from 'components/play-button.vue';
import MenuButton from 'components/menu-button.vue';
import AudioToggleButton from 'components/audio-toggle-button.vue';
import ThemeMenu from './theme-menu.vue'
import ScoreMenu from './score-menu.vue'
import ColorFactMenu from './color-fact-menu.vue';
import { ref, onBeforeUnmount, onMounted } from 'vue';
import { useModule } from 'src/modules/modules';
import { fromLocalStorage, mergeIntoLocalStorage } from 'util/util';
import GameBackground from 'components/game-background.vue';
import { showBanner } from 'util/ad-util'
import { hapticsImpactLight } from 'src/util/device-util';
import TutorialMenu from './tutorial-menu.vue';
import random from 'lodash/random'

enum Screen {
    MENU = 'menu',
    SCORES = 'SCORES',
    THEME = 'THEME',
    COLOR_FACT = 'COLOR_FACT',
    TUTORIAL = 'TUTORIAL'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'menu',
  setup(__props) {

_useCssVars(_ctx => ({
  "1ad357ca": (_unref(theme).theme.fontColor),
  "c7e3fb78": (_unref(theme).theme.titleBg)
}))

const { audio } = useModule();

const { global, theme, tutorial } = useModule();
const screen = ref<Screen>(Screen.MENU);

const handlePlay = () => {
    tutorial.setActiveIfNotViewed();
    global.startScene('Game');
}

const handleTutorialClicked = () => {
    screen.value = Screen.TUTORIAL;
    // tutorial.setActive(true);
    // global.startScene('Game');
}

const handleThemeClicked = () => screen.value = Screen.THEME;
const handleScoresClicked = () => screen.value = Screen.SCORES;
const handleColorFactClicked = () => {
    hapticsImpactLight();
    audio.play('FX_menu_btn');
    screen.value = Screen.COLOR_FACT;
}
const handleRemoveAds = () => {  }

onMounted(() => {
    showBanner();
})

return (_ctx: any,_cache: any) => {
  return (screen.value === Screen.MENU)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(GameBackground, {
          style: _normalizeStyle(_unref(theme).menuBg)
        }, null, 8, ["style"]),
        _createVNode(AudioToggleButton, { class: "audio-toggle-pos" }),
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(PlayButton, { onClick: handlePlay })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(MenuButton, {
            "icon-class": "bi bi-paint-bucket",
            label: "Theme",
            onClick: handleThemeClicked
          }),
          _createVNode(MenuButton, {
            "icon-class": "bi bi-trophy",
            label: "Stats",
            onClick: handleScoresClicked
          }),
          _createVNode(MenuButton, {
            "icon-class": "bi bi-book",
            label: "Tutorial",
            "audio-key": "FX_menu_btn_play",
            onClick: handleTutorialClicked
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(GlowButton, {
            onClick: handleRemoveAds,
            "full-width": ""
          }, {
            icon: _withCtx(() => [
              _hoisted_6
            ]),
            label: _withCtx(() => [
              _hoisted_7
            ]),
            description: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]))
    : (screen.value === Screen.THEME)
      ? (_openBlock(), _createBlock(ThemeMenu, {
          key: 1,
          onBack: _cache[0] || (_cache[0] = ($event: any) => (screen.value = Screen.MENU))
        }))
      : (screen.value === Screen.SCORES)
        ? (_openBlock(), _createBlock(ScoreMenu, {
            key: 2,
            onBack: _cache[1] || (_cache[1] = ($event: any) => (screen.value = Screen.MENU))
          }))
        : (screen.value === Screen.COLOR_FACT)
          ? (_openBlock(), _createBlock(ColorFactMenu, {
              key: 3,
              onBack: _cache[2] || (_cache[2] = ($event: any) => (screen.value = Screen.MENU))
            }))
          : (_openBlock(), _createBlock(TutorialMenu, {
              key: 4,
              onBack: _cache[3] || (_cache[3] = ($event: any) => (screen.value = Screen.MENU))
            }))
}
}

})